"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var bridge_1 = __importDefault(require("@stremio/stremio-core-web/bridge"));
var activeProfile_1 = require("stremio/plus/activeProfile");
var profileStorage_1 = __importDefault(require("stremio/plus/profileStorage"));
var api_1 = require("stremio/plus/api");
var worker = new Worker("".concat(process.env.COMMIT_HASH, "/scripts/worker.js"));
// What the core worker can reach on this side of the bridge.
// localStorage goes through profileStorage so each profile keeps its own local data.
var scope = {
    localStorage: profileStorage_1.default,
    location: window.location,
    get onCoreEvent() {
        return window.onCoreEvent;
    },
};
var bridge = new bridge_1.default(scope, worker);
// The kids filter in the worker needs the Stremio session before the core has loaded it.
var getStoredAuthKey = function () {
    var _a, _b, _c, _d;
    try {
        return (_d = (_c = (_b = JSON.parse((_a = localStorage.getItem('profile')) !== null && _a !== void 0 ? _a : 'null')) === null || _b === void 0 ? void 0 : _b.auth) === null || _c === void 0 ? void 0 : _c.key) !== null && _d !== void 0 ? _d : null;
    }
    catch (_e) {
        return null;
    }
};
var createTransport = function () {
    var init = function (args) {
        return bridge.call(['init'], [__assign(__assign({}, args), { stremioPlus: {
                    profile: (0, activeProfile_1.getActiveProfile)(),
                    apiUrl: api_1.STREMIO_PLUS_API,
                    authKey: getStoredAuthKey(),
                } })]);
    };
    var getState = function (model) {
        return bridge.call(['getState'], [model]);
    };
    var dispatch = function (action, model) {
        return bridge.call(['dispatch'], [action, model, location.hash]);
    };
    var encodeStream = function (stream) {
        return bridge.call(['encodeStream'], [stream]);
    };
    var decodeStream = function (stream) {
        return bridge.call(['decodeStream'], [stream]);
    };
    var analytics = function (event) {
        return bridge.call(['analytics'], [event, location.hash]);
    };
    return {
        init: init,
        getState: getState,
        dispatch: dispatch,
        encodeStream: encodeStream,
        decodeStream: decodeStream,
        analytics: analytics,
    };
};
exports.default = createTransport;
